<template>
    <v-row class="ma-0 transition-all option" >
        <v-col cols="auto" class="pl-1">
            <v-img
                :src="soundDefault"
                max-height="45px"
                max-width="45px"
                :min-height="$vuetify.breakpoint.xs ? '32' : '40'"
                :min-width="$vuetify.breakpoint.xs ? '32' : '40'"
                contain
                class="main-sound-img cursor-pointer"
                @click="readText(isReading ? answer.content : answer.contenido), iconListenQuestion()"
            ></v-img>
        </v-col>
        <v-col
            data-cy="questionItem-item-selection"
            cols=""
            :key="'radio-' + question.id + '-' + answer.id"
            :id="answer.id"
            v-ripple
            :class="`${styles}`"
            @click="setSelectedBtn"
            elevation="0"
        >
        <span
        >{{ $utils.capitalizeWord(isReading ? answer.content : answer.contenido) }}</span>
        </v-col>
    </v-row>
</template>

<script>
    import SpeechSynthesis from "../../../../mixins/SpeechSynthesis";
    import initialReaderValidation from "../../../../mixins/InitialReaderValidation";
    export default {
        name: "TextOption",
        props: {
            answer: {type: Object, default: () => ({})},
            question: {type: Object, default: () => ({})},
            selected: {type: Boolean, default: () => ({})},
            isReading: {type: Boolean, default: false},
            correct: {type: Boolean, default: false},
            incorrect: {type: Boolean, default: false},
        },
        computed: {
            styles() {
                return `alternative w-100 my-3 mx-2 text-center overflow-hidden transition-all ${this.isInitialReader ? 'text-h5': 'text-h6'} cursor-pointer pa-2 border-radius-1 text-none option-btn pa-0 line-height-140
                ${this.colorForOption}`
            },
            colorForOption(){
                if(this.correct) return 'correct white--text';
                if(this.incorrect) return 'incorrect white--text';
                if(this.selected) return 'primary white--text';

                return 'bg-primary-30 dark--text'
            },
        },
        data() {
            return {
                btnSelected: {
                    id: null,
                    value: null,
                    secret: null,
                },
                soundDefault: require(`@/assets/img/icons/icon-voice-assistant.svg`),
            }
        },
        methods: {
            setSelectedBtn() {
                this.$emit('select', {
                    id: this.answer.id,
                    value: this.answer.id,
                    secret: this.answer.item,
                })
            },
            iconListenQuestion() {
                this.soundDefault = require(`@/assets/img/icons/icon-voice-assistant-select.svg`);
                setTimeout(() => {
                    this.soundDefault = require(`@/assets/img/icons/icon-voice-assistant.svg`);
                }, 1500)
            },
        },
        mixins: [SpeechSynthesis, initialReaderValidation]
    }
</script>

<style scoped>
    .option-img {
        width: 100%;
        height: 100%;
        display: block;
        box-sizing: border-box;
    }
</style>
